import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";

export interface LinkFileModalState {
  linkFileModal: {
    openModal: boolean;
    link: string;
  };
}

const initialState: LinkFileModalState = {
  linkFileModal: { openModal: false, link: "" },
};

export const linkFileModalSlice = createSlice({
  name: "linkFileModal",
  initialState,
  reducers: {
    linkFileModalAction: (state, action: PayloadAction<boolean>) => {
      state.linkFileModal = action.payload
        ? { ...state.linkFileModal, openModal: action.payload }
        : { ...state.linkFileModal, openModal: action.payload, link: "" };
    },
    setLinkFileModalAction: (state, action: PayloadAction<string>) => {
      state.linkFileModal.link = action.payload;
    },
  },
});

export const { linkFileModalAction, setLinkFileModalAction } =
  linkFileModalSlice.actions;

export const linkFileModal = (state: RootState) => state.linkFileModalState;

export default linkFileModalSlice.reducer;
